// src/pages/Home.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../utils/env';
import { useTelegramWebApp } from '../hooks/useTelegramWebApp';
import { Logo } from '../components/logo';
import { AuthButtons } from '../components/sign_up_in';
import fon from '../components/4.png';
import image10 from '../components/5.png';
import { getToken } from '../utils/token';
import { getEmail } from '../utils/token';
// 2. Потом любые типы / константы
type CardProps = { number: number; text: string; top: number };

const FrameCard: React.FC<CardProps> = ({ number, text, top }) => (
  <div
    style={{
      position: 'absolute',
      width: 619,
      height: 111,
      left: 193,
      top,
    }}
  >
    {/* glass-фон */}
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(127,56,243,.2)',
        backgroundBlendMode: 'plus-lighter',
        mixBlendMode: 'normal',
        boxShadow: `
          -11.1504px -10.392px 48px -12px rgba(0,0,0,.15),
          -1.8584px -1.732px 12px -8px rgba(0,0,0,.15),
          inset 2.00707px 1.87056px 8.64px rgba(255,255,255,.15),
          inset 1.07787px 1.00456px 4.32px rgba(255,255,255,.15)`,
        backdropFilter: 'blur(4.88px)',
        borderRadius: 50,
      }}
    />

    {/* текст */}
    <div
      style={{
        position: 'absolute',
        width: 475,
        height: 66,
        left: 34,
        top: 23,
        fontFamily: `'SF Pro', sans-serif`,
        fontWeight: 510,
        fontSize: 28,
        lineHeight: '33px',
        textAlign: 'left',
        color: number === 3 ? '#FFFFFF' : 'rgba(255,255,255,0.8)',
      }}
    >
      {text}
    </div>

    {/* круг-номер */}
    <div
      style={{
        position: 'absolute',
        width: 80.1,
        height: 80.1,
        left: number === 3 ? 521 : 518,
        top: 16,
        background: 'linear-gradient(90deg, rgba(109,29,125,.8) 0%, rgba(95,11,232,.8) 100%)',
        mixBlendMode: 'normal',
        boxShadow: `
          -10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,.15),
          -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,.15),
          inset 1.93181px 1.80041px 8.316px rgba(255,255,255,.126),
          inset 1.09553px 1.02101px 4.158px rgba(255,255,255,.126)`,
        backdropFilter: 'blur(6.822px)',
        borderRadius: '50%',
        zIndex:100,
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: number === 3 ? 22 : number === 2 ? 22 : 24,
          top: 5,
          fontFamily: `'Inter Hewn', sans-serif`,
          fontWeight: 700,
          fontSize: 64,
          lineHeight: '77px',
          color: '#FFFFFF',
          textAlign:"left",
          zIndex:100,
        }}
      >
        {number}
      </div>
    </div>
  </div>
);
export const Affiliate = () => {
  const [authMode, setAuthMode] = useState<null | 'login' | 'signup'>(null);
  const openLogin = () => setAuthMode('login');
  const openSignUp = () => setAuthMode('signup');
  const [broker, setBroker] = useState<'quotex' | 'pocket'>('quotex');
  const navigate = useNavigate();
  const [idValue, setIdValue] = useState('');
  const [idError, setIdError] = useState('');
  const { user } = useTelegramWebApp();
  const BROKER_URLS = {quotex: 'https://broker-qx.pro/sign-up/?lid=1615626',pocket: 'https://po-ru4.click/smart/J5mm7CVtrmi5nb',};
  const handleRegistration = () => {
    const url = BROKER_URLS[broker]; // выбранный брокер
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const handleRegisterId = async () => {
    setIdError(''); // сброс ошибки
    if (!idValue.trim()) {
      setIdError('Enter your ID');
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/register-id`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(getToken() && { Authorization: `Bearer ${getToken()}` }),
        },
        body: JSON.stringify({
          id: idValue.trim(),
          email: getEmail(),
        }),
      });

      // 429 – «слишком много запросов» → показываем кнопку активации
      if (res.status === 429) {
        setIdError('429'); // спец-метка для рендера кнопки
        return;
      }

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Server error');
      }

      // успех – переход на страницу анализа
      navigate('/ai');
    } catch (e: any) {
      setIdError(e.message || 'Failed to register ID');
    }
  };
  return (
    <div
      style={{
        position: 'relative',
        minHeight: '100vh',
        background: 'linear-gradient(314.56deg, #0A090C 0.38%, #1A092D 99.62%)',
        overflowX: 'hidden',
      }}
    >
      {/* Фоновое изображение */}
      <img
        src={fon}
        alt="Background"
        style={{
          position: 'absolute',
          width: 1404,
          height: 790,
          left: -37,
          top: -184,
          objectFit: 'cover',
          zIndex: 0,
          mixBlendMode: 'color-dodge',
          opacity: 0.2,
        }}
      />
      <img
        src={image10}
        alt="Background"
        style={{
          position: 'absolute',
          width: 1207,
          height: 679,
          left: -27,
          top: 698,
          objectFit: 'cover',
          zIndex: 0,
          mixBlendMode: 'color-dodge',
          opacity: 0.2,
        }}
      />
      ///////////////////////////////////
        <div
        style={{
            position: 'absolute',
            width: 780,
            height: 76,
            left: 'calc(50% - 780px/2 + 0.5px)',
            top: 230,
            cursor: 'pointer',
            userSelect: 'none',
        }}
        onClick={() => setBroker((b) => (b === 'quotex' ? 'pocket' : 'quotex'))}
        >
        {/* glass track */}
        <div
            style={{
                position: 'absolute',
                width: 780,
                height: 76,
                left: 0,
                top: 0,
                background: 'rgba(99, 48, 193, 0.3)',
                backgroundBlendMode: 'plus-lighter',
                mixBlendMode: 'normal',
                boxShadow: `
                    -21.4088px -19.9526px 92.16px -23.04px rgba(0,0,0,0.15),
                    -3.56813px -3.32544px 23.04px -15.36px rgba(0,0,0,0.15),
                    inset 3.56813px 3.32544px 15.36px rgba(255,255,255,0.15),
                    inset 1.78406px 1.66272px 7.68px rgba(255,255,255,0.15)
                `,
                backdropFilter: 'blur(3.84px)',
                borderRadius: 78.72,
                transform: 'matrix(-1, 0, 0, 1, 0, 0)',
                }}
        />

        {/* sliding active pill */}
        <div
            style={{
            position: 'absolute',
            width: broker === 'quotex'
                ? 349
                : 410,
            height: 76,
            top: 0,
            left: broker === 'quotex' ? 0 : 361,
            background:
                broker === 'quotex'
                ? 'linear-gradient(90deg, #7c3aed 0%, #a855f7 100%)'
                : 'linear-gradient(90deg, #db2777 0%, #ec4899 100%)',
            boxShadow: `
                0 4px 24px rgba(0,0,0,.25),
                inset 0 1px 1px rgba(255,255,255,.25)`,
            borderRadius: 78.72,
            transition: 'left .45s cubic-bezier(.4,1.8,.6,1)',
            }}
        />

        {/* Quotex label */}
        <div
            style={{
            position: 'absolute',
            width: 152,
            height: 57,
            left: 99,
            top: 9,
            fontFamily: `'SF Pro', sans-serif`,
            fontWeight: 600,
            fontSize: 48,
            lineHeight: '57px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: broker === 'quotex' ? '#fff' : 'rgba(255,255,255,.55)',
            transition: 'color .35s',
            }}
        >
            Quotex
        </div>

        {/* PocketOption label */}
        <div
            style={{
            position: 'absolute',
            width: 284,
            height: 57,
            left: 409,
            top: 9,
            fontFamily: `'SF Pro', sans-serif`,
            fontWeight: 600,
            fontSize: 48,
            lineHeight: '57px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: broker === 'pocket' ? '#fff' : 'rgba(255,255,255,.55)',
            transition: 'color .35s',
            }}
        >
            PocketOption
        </div>
        </div>
      ///////////////////////////////////
            {/* ========== Frame 32 – контейнер всего блока ========== */}
        <div
        style={{
            position: 'absolute',
            width: 1043,
            height: 618,
            left: 'calc(50% - 1043px/2)',
            top: 375,
        }}
        >
        {/* центральный glass-фон (733×594) */}
        <div
            style={{
            position: 'absolute',
            width: 733,
            height: 594,
            left: 155,
            top: 12,
            background: 'linear-gradient(90deg, rgba(109,29,125,.3) 0%, rgba(95,11,232,.3) 100%)',
            mixBlendMode: 'normal',
            boxShadow: `
                -11.1504px -10.392px 48px -12px rgba(0,0,0,.15),
                -1.8584px -1.732px 12px -8px rgba(0,0,0,.15),
                inset 2.39734px 2.23428px 10.32px rgba(255,255,255,.15),
                inset 1.46814px 1.36828px 5.16px rgba(255,255,255,.15)`,
            backdropFilter: 'blur(12.44px)',
            borderRadius: 50,
            }}
        />

        {/* заголовок + декоративная полоса */}
        <div
            style={{
            position: 'absolute',
            width: 554,
            height: 8,
            left: 255,
            top: 127,
            background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
            borderRadius: 50,
            }}
        />
        <div
            style={{
            position: 'absolute',
            width: 600,
            height: 54,
            left: 220,
            top: 62,
            fontFamily: `'SF Pro', sans-serif`,
            fontStyle: 'normal',
            fontWeight: 510,
            fontSize: 45,
            lineHeight: '54px',
            color: '#FFFFFF',
            }}
        >
            Broker <span style={{ color: 'transparent', background: 'linear-gradient(to right, #b84ecdff, #5F0BE8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Access</span> Requirements
        </div>

        {/* --------- карточка 1 --------- */}
        <FrameCard
            number={1}
            text="Register with one of our partner brokers using the link provided."
            top={178}
        />

        {/* --------- карточка 2 --------- */}
        <FrameCard
            number={2}
            text="Make a minimum deposit of $50 to activate your trading account."
            top={313}
        />

        {/* --------- карточка 3 --------- */}
        <FrameCard
            number={3}
            text="After registration, please write your ID below"
            top={448}
        />
        </div>
      ///////////////////////////////////
    {/* ====== Frame 33 – «Registration» big button ====== */}
    <div
    style={{
        position: 'absolute',
        width: 391,
        height: 96,
        left: 'calc(50% - 391px/2 - 6px)',
        top: 1017,
        cursor: 'pointer',
    }}
    >
    {/* gradient background */}
    <div
        style={{
        position: 'absolute',
        width: 388,
        height: 78,
        left: 3,
        top: 0,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
        mixBlendMode: 'normal',
        boxShadow: `
            -10.5973px -9.87656px 45.6192px -11.4048px rgba(0,0,0,0.15),
            -1.76622px -1.64609px 11.4048px -7.6032px rgba(0,0,0,0.15),
            inset 1.76622px 1.64609px 7.6032px rgba(255,255,255,0.15),
            inset 0.883112px 0.823046px 3.8016px rgba(255,255,255,0.15)`,
        backdropFilter: 'blur(1.9008px)',
        borderRadius: 48,
        }}
    />

    {/* white circle with key icon */}
    <div
        style={{
        position: 'absolute',
        width: 78,
        height: 78,
        left: 313,
        top: 0,
        background: '#FFFFFF',
        mixBlendMode: 'normal',
        boxShadow: `
            -10.5973px -9.87656px 45.6192px -11.4048px rgba(0,0,0,0.15),
            -1.76622px -1.64609px 11.4048px -7.6032px rgba(0,0,0,0.15),
            inset 1.76622px 1.64609px 7.6032px rgba(255,255,255,0.15),
            inset 0.883112px 0.823046px 3.8016px rgba(255,255,255,0.15)`,
        backdropFilter: 'blur(1.9008px)',
        borderRadius: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        }}
    >
        {/* key icon (tabler:key-filled) */}
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.91 0C23.7107 0 25.4362 0.71575 26.7085 1.988L33.012 8.2915C33.642 8.92153 34.1418 9.66948 34.4828 10.4927C34.8238 11.3158 34.9993 12.1981 34.9993 13.0891C34.9993 13.9801 34.8238 14.8624 34.4828 15.6856C34.1418 16.5088 33.642 17.2567 33.012 17.8867L28.3867 22.512C27.2647 23.6329 25.7857 24.3258 24.2063 24.4702C22.6269 24.6147 21.0468 24.2018 19.74 23.303L19.5562 23.1665L9.26275 33.4618C8.46608 34.2557 7.43548 34.7729 6.32275 34.937L5.93775 34.9842L5.551 35H3.5C1.7255 35 0.23275 33.6717 0.0157501 31.8097L0 31.5V29.449C0 28.217 0.434 27.0235 1.2775 26.019L1.53825 25.7373L2.26275 25.0127C2.59086 24.6845 3.03591 24.5001 3.5 24.5H5.25V22.75C5.25006 22.3214 5.40742 21.9077 5.69225 21.5873C5.97708 21.267 6.36956 21.0624 6.79525 21.0122L7 21H8.75V19.25C8.74997 18.8654 8.87667 18.4914 9.1105 18.186L9.26275 18.011L11.8317 15.4403L11.6987 15.26C11 14.2432 10.59 13.056 10.5122 11.8247L10.5 11.4117C10.5 9.611 11.2157 7.8855 12.488 6.61325L17.1132 1.988C18.3856 0.716004 20.1108 0.000996559 21.91 0ZM22.7762 8.75H22.7412C21.813 8.75 20.9228 9.11875 20.2664 9.77513C19.61 10.4315 19.2412 11.3217 19.2412 12.25C19.2412 13.1783 19.61 14.0685 20.2664 14.7249C20.9228 15.3813 21.813 15.75 22.7412 15.75H22.7762C23.7045 15.75 24.5947 15.3813 25.2511 14.7249C25.9075 14.0685 26.2762 13.1783 26.2762 12.25C26.2762 11.3217 25.9075 10.4315 25.2511 9.77513C24.5947 9.11875 23.7045 8.75 22.7762 8.75Z" fill="url(#paint0_linear_31_709)"/>
        <defs>
        <linearGradient id="paint0_linear_31_709" x1="0" y1="17.5" x2="34.9993" y2="17.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D1D7D"/>
        <stop offset="1" stop-color="#5F0BE8"/>
        </linearGradient>
        </defs>
        </svg>

    </div>

    {/* Registration text */}
    <div
        style={{
        position: 'absolute',
        width: 190,
        height: 44,
        left: 81,
        top: 16,
        fontFamily: `'SF Pro', sans-serif`,
        fontStyle: 'normal',
        fontWeight: 510,
        fontSize: 36.4954,
        lineHeight: '44px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        color: '#FFFFFF',
        }}
        onClick={handleRegistration}
    >
        Registration
    </div>
    </div>

    {/* ====== подсказка ====== */}
    <div
    style={{
        position: 'absolute',
        width: 472,
        height: 29,
        left: 'calc(50% - 482px/2 + 0.5px)',
        top: 1133,
        fontFamily: `'SF Pro', sans-serif`,
        fontStyle: 'normal',
        fontWeight: 510,
        fontSize: 24,
        lineHeight: '29px',
        textAlign: 'right',
        color: 'rgba(255,255,255,0.6)',
    }}
    >
    If you already have an account, enter the ID
    </div>

    {/* ====== Frame 34 – ввод ID ====== */}
    {/* ====== Frame 34 – ввод ID ====== */}
<div
  style={{
    position: 'absolute',
    width: 334.86,
    height: 78,
    left: 'calc(50% - 334.86px/2 - 0.07px)',
    top: 1199,
  }}
>
  {/* glass input-bg */}
  <div
    style={{
      position: 'absolute',
      inset: 0,
      background: 'rgba(99,48,193,.2)',
      backgroundBlendMode: 'plus-lighter',
      mixBlendMode: 'normal',
      boxShadow: `
        -14.9954px -13.9754px 64.5517px -16.1379px rgba(0,0,0,0.15),
        -2.49923px -2.32924px 16.1379px -10.7586px rgba(0,0,0,0.15),
        inset 3.47393px 3.23765px 14.9545px rgba(255,255,255,0.15),
        inset 2.22431px 2.07302px 7.47724px rgba(255,255,255,0.15)`,
      backdropFilter: 'blur(21.571px)',
      borderRadius: 38.8171,
    }}
  />

  {/* живой input */}
  <input
    value={idValue}
    onChange={(e) => setIdValue(e.target.value)}
    placeholder="Enter Your ID"
    style={{
      position: 'absolute',
      left: 42.59,
      top: 20.17,
      width: 190,
      height: 39,
      background: 'transparent',
      border: 'none',
      outline: 'none',
      fontFamily: `'SF Pro', sans-serif`,
      fontWeight: 510,
      fontSize: 32.2759,
      color: '#fff',
    }}
  />

  {/* стрелка-отправка */}
  <div
    style={{
      position: 'absolute',
      width: 78,
      height: 78,
      left: 257,
      top: 1,
      background: 'linear-gradient(90deg, rgba(109,29,125,.8) 0%, rgba(95,11,232,.8) 100%)',
      mixBlendMode: 'normal',
      boxShadow: `
        -9.41986px -8.77916px 40.5504px -10.1376px rgba(0,0,0,0.15),
        -1.56998px -1.46319px 10.1376px -6.7584px rgba(0,0,0,0.15),
        inset 1.56998px 1.46319px 6.7584px rgba(255,255,255,0.15),
        inset 0.784988px 0.731597px 3.3792px rgba(255,255,255,0.15)`,
      backdropFilter: 'blur(1.6896px)',
      borderRadius: 34.6368,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    }}
    onClick={handleRegisterId}
  >
    <svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.3009 0.800283C21.8134 0.287862 22.5086 0 23.2333 0C23.9581 0 24.6532 0.287862 25.1658 0.800283L37.4658 13.1003C37.9782 13.6129 38.2661 14.308 38.2661 15.0327C38.2661 15.7575 37.9782 16.4526 37.4658 16.9652L25.1658 29.2652C24.6503 29.7631 23.9598 30.0386 23.2432 30.0324C22.5265 30.0262 21.8409 29.7387 21.3342 29.2319C20.8274 28.7251 20.5399 28.0396 20.5337 27.3229C20.5275 26.6062 20.803 25.9158 21.3009 25.4003L28.7 17.7661H2.73333C2.00841 17.7661 1.31317 17.4781 0.800575 16.9655C0.287975 16.4529 0 15.7577 0 15.0327C0 14.3078 0.287975 13.6126 0.800575 13.1C1.31317 12.5874 2.00841 12.2994 2.73333 12.2994H28.7L21.3009 4.66522C20.7884 4.15264 20.5006 3.45753 20.5006 2.73275C20.5006 2.00797 20.7884 1.31286 21.3009 0.800283Z" fill="white"/>
    </svg>

  </div>

  {/* блок ошибки / кнопка 429 */}
  {idError && (
    <div style={{ position: 'absolute', top: 90, left: 0, right: 0, textAlign: 'center' }}>
      {idError === '429' ? (
        <button
          onClick={() => navigate('/activate')}
          style={{
            marginTop: 12,
            padding: '10px 24px',
            background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
            border: 'none',
            borderRadius: 28,
            fontFamily: `'SF Pro', sans-serif`,
            fontWeight: 600,
            fontSize: 18,
            color: '#fff',
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(95,11,232,.35)',
          }}
        >
          Активировать аккаунт
        </button>
      ) : (
        <span style={{ fontFamily: `'SF Pro', sans-serif`, fontSize: 16, color: '#FF4444' }}>{idError}</span>
      )}
    </div>
  )}
</div>
      ///////////////////////////////////
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1440, margin: '0 auto' }}>
              <Logo />
              <AuthButtons onLogin={openLogin} onSignUp={openSignUp} />
            </div>
      
    </div>
  );
};